import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import EventGraphQL from '@graphql/event.queries';
import { Event } from '@models/event.model';

interface UpdateEventInput {
  eventId: string;
  name: string;
  eventType: string;
  otherEventType?: string | null;
  eventTime: Date | string;
  incidentType?: string | null;
  addedIncidentType?: string | null;
  inspectionType?: string | null;
  permit?: string | null;
  delay?: number | null;
  delayType?: string | null;
  notes?: string | null;
  precedentTaskId?: string[];
  projectId: string;
}

interface UseUpdateEventReturn {
  updateEvent: (input: UpdateEventInput) => Promise<Event | null>;
  loading: boolean;
  error: string | null;
}

export const useUpdateEvent = (): UseUpdateEventReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateEvent = useCallback(
    async (input: UpdateEventInput): Promise<Event | null> => {
      setLoading(true);
      setError(null);

      try {
        const data: any = await graphQlClient.request(
          EventGraphQL.mutations.updateEvent,
          { event: input },
        );

        return data?.updateEvent || null;
      } catch (err: any) {
        const errorMessage =
          err?.response?.errors?.[0]?.message || 'Failed to update event';
        setError(errorMessage);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    updateEvent,
    loading,
    error,
  };
};
